export default __webpack_public_path__ + "static/media/16.2e0749e4.png";